import { ICON_DATA } from '../../shared/components/icon/icon-data.generated';
import { TourType } from './tour-config';

export function waitForElement(elementId: string, checkInterval = 100, timeoutInterval = 5000) {
  return new Promise(resolve => {
    const interval = setInterval(() => {
      const element = document.getElementById(elementId);
      if (element) {
        clearInterval(interval);
        resolve(element);
      }
    }, checkInterval);

    const timeout = setInterval(() => {
      clearInterval(interval);
      clearInterval(timeout);
      resolve(null);
    }, timeoutInterval);
  });
}

export function getStorageKeyByTourType(tourType: TourType): string {
  return `patientPortal${TourType[tourType]}TourCompleted`;
}

export function generateIcon(name: string): string {
  const iconSvg = ICON_DATA[name];

  return iconSvg
    .replace(/fill="[^"]*"/g, `fill="currentColor"`)
    .replace(/width="[^"]*"/g, `width="20"`)
    .replace(/height="[^"]*"/g, `height="20"`);
}

// Used in the case where an element may not be present for all users; e.g., no past appointments yet.
export function getTargetElementIdOrFallback(targetElementId: string, fallbackElementIdentifier: string) {
  return document.getElementById(targetElementId) ? `#${targetElementId}` : fallbackElementIdentifier;
}
